import useSWRImmutable from 'swr'
import fetcher from './fetcher'

export default function useUpgradesDowngrades(stockId) {
  const { data, error, isLoading } = useSWRImmutable(`/react/upgrades_downgrades?stock_id=${stockId}`, fetcher)

  return {
    upgradesDowngrades: data,
    isLoading,
    error
  }
}